import { getCategoryNAField } from 'legacy/lut/components/widgets/public/partner360/planning/helpers/getCategoryNAField'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import { updateSectionSettings } from 'legacy/lut/features/partner360/sectionSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { changeAssortmentCategory } from 'partner360/features/assortment/assortmentSlice'
import { IAssortmentCategory } from 'partner360/features/assortment/models/data/IAssortmentCategory'

interface IOnChangeNotApplicableParams {
  isNotApplicable: boolean
  categoryField: string
}

interface IParams {
  partnerId: string
  fYear: number
  category: IAssortmentCategory
}

export const useAssortmentNotApplicable = ({ category, partnerId, fYear }: IParams) => {
  const dispatch = useAppDispatch()

  const changeNotApplicable = useCallback(
    async ({ isNotApplicable, categoryField }: IOnChangeNotApplicableParams) => {
      const categoryNAField = getCategoryNAField(categoryField)
      const settingsForUpdate = { [categoryNAField]: isNotApplicable ? 0 : 1 }

      dispatch(
        changeAssortmentCategory({
          ...category,
          IsApplicable: isNotApplicable ? 1 : 0,
        })
      )

      await dispatch(
        updateSectionSettings({
          sectionSettings: settingsForUpdate as any,
          flag: categoryNAField,
          state: settingsForUpdate[categoryNAField],
          controlName: 'Assortment',
        })
      ).unwrap()

      await dispatch(requestRecalculateCompleteness({ partnerId, fYear })).unwrap()
    },
    [dispatch, category, fYear, partnerId]
  )

  const changeAssortmentNotApplicable = useCallback(
    async (params: IOnChangeNotApplicableParams) => {
      await changeNotApplicable(params)
    },
    [changeNotApplicable]
  )

  return changeAssortmentNotApplicable
}
